import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, ShieldCheck, ShieldX } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Logo, MotionButton, AuthBackground, DevCredit } from "../components/common";
import { EASE } from "../components/motion";
import { CertView, PrintButton } from "./student/Certificates";

export default function Verify() {
  const { number } = useParams();
  const nav = useNavigate();
  const [q, setQ] = useState(number || "");
  const [state, setState] = useState({ loading: !!number, cert: null, error: "" });

  useEffect(() => {
    if (!number) return;
    setState({ loading: true, cert: null, error: "" });
    api.get(`/public/certificates/${encodeURIComponent(number)}`)
      .then((r) => setState({ loading: false, cert: r.data, error: "" }))
      .catch((e) => setState({ loading: false, cert: null, error: errMsg(e) }));
  }, [number]);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/dogrula/${encodeURIComponent(q.trim().toUpperCase())}`);
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[var(--canvas)] px-4 py-10">
      <div className="no-print"><AuthBackground /></div>
      <div className="relative z-10 mx-auto max-w-3xl">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: EASE }} className="no-print glass gradient-border rounded-[22px] p-6 sm:p-8">
          <Logo className="h-14 w-auto" />
          <h1 className="mt-5 text-2xl sm:text-3xl font-extrabold tracking-tight" data-testid="verify-title">Sertifika Doğrulama</h1>
          <p className="mt-1.5 text-sm text-slate-500">Sertifika numarasını girerek belgenin geçerliliğini kontrol edin.</p>
          <form onSubmit={submit} className="mt-6 flex flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Örn. SK-2026-000128" className="field h-12 pl-9 font-mono uppercase" data-testid="verify-number-input" />
            </div>
            <MotionButton type="submit" className="h-12" data-testid="verify-submit-btn">Doğrula</MotionButton>
          </form>
        </motion.div>

        {state.loading && <div className="skeleton mt-6 h-80" />}
        {state.error && (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="no-print surface mt-6 flex items-center gap-3 p-5 text-rose-700" data-testid="verify-invalid">
            <ShieldX className="h-6 w-6 shrink-0" /> <p className="text-sm font-semibold">{state.error}</p>
          </motion.div>
        )}
        {state.cert && (
          <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: EASE }} className="mt-6 space-y-4">
            <div className="no-print surface flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid="verify-valid">
              <p className="flex items-center gap-2 text-sm font-semibold text-emerald-700"><ShieldCheck className="h-5 w-5" /> Bu sertifika geçerlidir ve SK Enstitü tarafından düzenlenmiştir.</p>
              <PrintButton c={state.cert} />
            </div>
            <CertView c={state.cert} />
          </motion.div>
        )}
        <div className="no-print mt-10"><DevCredit /></div>
      </div>
    </div>
  );
}
